'use strict';

var Consts = require('consts');
var Misc = require('utils/misc');

var TabsView = Marionette.ItemView.extend({
    template: require('components/scheme/templates/tabs'),

    ui: {
        schemaTab: '.js-schema-tab',
    },

    events: {
        'click @ui.schemaTab': 'switchTabs',
    },

    initialize: function (options) {
        this.tabs = options.tabs;
        this.data = {};
        _.each(
            options.data,
            function (value, dataPointName) {
                this.data[Consts.SchemaElementsToDataPoint[dataPointName]] = value;
            },
            this
        );
        this.activeTab = options.activeTab || 0;
        this.tabs[this.activeTab].active = true;
    },

    serializeData: function () {
        var self = this;
        // display warning for a tab? -> check their conditions
        _.each(this.tabs, function (tab) {
            if (tab.highlight) {
                var isHighlight = true;
                _.each(tab.highlight.conditions, function (c) {
                    isHighlight =
                        isHighlight && Misc.evaluateToBool(self.data[c.dataPoint], c.operator || '==', c.value);
                });
                tab.warning = isHighlight;
            }
        });
        return { tabs: this.tabs };
    },

    switchTabs: function (e) {
        // clicked same tab? -> do nothing
        if (e.currentTarget.id === this.activeTab) {
            return;
        }
        this.activeTab = parseInt(e.currentTarget.id);
        _.each(
            this.tabs,
            function (tab, index) {
                tab.active = index == this.activeTab;
            },
            this
        );
        this.triggerMethod('switched:tab', this.activeTab);
    },
});

module.exports = TabsView;
